import { Button, Modal } from 'antd';
import {
  FaArrowUp,
  FaCalendarAlt,
  FaCheck,
  FaCreditCard,
  FaEye,
  FaFileAlt,
  FaIdCard,
  FaMoneyBillWave,
  FaTimes,
  FaUniversity,
  FaUser,
  FaUserEdit,
} from 'react-icons/fa';

import { Money } from '~/components/Status';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStateContext } from '~/contexts/ContextProvider';

export default function DetailsRechargeMobile({ data }) {
  const { formatMoney } = useStateContext();
  const { t } = useTranslation('report');
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        className="flex items-center justify-center text-white transition-all duration-300 border-none rounded-lg shadow-lg bg-gradient-to-r from-green-500 to-emerald-600 hover:scale-105 hover:shadow-xl"
        icon={<FaEye />}>
        {/* {t("chi tiet")} */}
      </Button>

      <Modal
        open={open}
        closable={false}
        width={400}
        centered
        footer={null}
        className="custom-recharge-modal"
        bodyStyle={{ padding: 0 }}
        maskStyle={{
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        }}>
        <div className="overflow-hidden bg-white rounded-2xl">
          {/* Header */}
          <div className="flex items-center justify-center gap-5 p-4 text-center text-white bg-gradient-to-r from-green-500 to-emerald-600">
            <FaArrowUp className="mb-2 text-xl" />
            <h3 className="m-0 text-lg font-bold">{t('chi_tiet_nap_tien')}</h3>
          </div>

          {/* Content */}
          <div className="p-4 space-y-2">
            {/* Số tiền */}
            <div className="flex items-center gap-3 p-3 bg-gray-100 rounded-lg">
              <div className="p-2 bg-green-100 rounded-lg">
                <FaMoneyBillWave className="text-lg text-green-600" />
              </div>
              <div className="flex-1">
                <div className="mb-1 text-sm text-gray-600">{t('sotien')}:</div>
                <div className="text-lg font-bold text-green-600">{formatMoney(data?.amount)}</div>
              </div>
            </div>

            {/* Người chơi */}
            <div className="flex items-center gap-3 p-3 bg-gray-100 rounded-lg">
              <div className="p-2 bg-blue-100 rounded-lg">
                <FaUser className="text-lg text-blue-600" />
              </div>
              <div className="flex-1">
                <div className="mb-1 text-sm text-gray-600">{t('nguoichoi')}:</div>
                <div className="font-medium text-gray-800">{data?.username}</div>
              </div>
            </div>

            {/* Trạng thái */}
            <div className="flex items-center gap-3 p-3 bg-gray-100 rounded-lg">
              <div className="p-2 bg-green-100 rounded-lg">
                <FaCheck className="text-lg text-green-600" />
              </div>
              <div className="flex-1">
                <div className="mb-1 text-sm text-gray-600">{t('trangthai')}:</div>
                <Money status={data?.status} />
              </div>
            </div>

            {/* Nội dung */}
            <div className="flex items-start gap-3 p-3 bg-gray-100 rounded-lg">
              <div className="p-2 bg-purple-100 rounded-lg">
                <FaFileAlt className="text-lg text-purple-600" />
              </div>
              <div className="flex-1">
                <div className="mb-1 text-sm text-gray-600">{t('noidung')}:</div>
                <div className="text-gray-800 break-words">{data?.description}</div>
              </div>
            </div>

            {/* Mã giao dịch */}
            <div className="flex items-center gap-3 p-3 bg-gray-100 rounded-lg">
              <div className="p-2 bg-indigo-100 rounded-lg">
                <FaIdCard className="text-lg text-indigo-600" />
              </div>
              <div className="flex-1">
                <div className="mb-1 text-sm text-gray-600">{t('magiaodich')}:</div>
                <div className="font-mono text-gray-800">#{data?.id}</div>
              </div>
            </div>

            {/* Ngân hàng */}
            <div className="flex items-center gap-3 p-3 bg-gray-100 rounded-lg">
              <div className="p-2 bg-orange-100 rounded-lg">
                <FaUniversity className="text-lg text-orange-600" />
              </div>
              <div className="flex-1">
                <div className="mb-1 text-sm text-gray-600">{t('nganhang')}:</div>
                <div className="font-medium text-gray-800">{data?.bank}</div>
              </div>
            </div>

            {/* Họ tên */}
            <div className="flex items-center gap-3 p-3 bg-gray-100 rounded-lg">
              <div className="p-2 bg-teal-100 rounded-lg">
                <FaUserEdit className="text-lg text-teal-600" />
              </div>
              <div className="flex-1">
                <div className="mb-1 text-sm text-gray-600">{t('hoten')}:</div>
                <div className="font-medium text-gray-800">{data?.bank_account}</div>
              </div>
            </div>

            {/* STK */}
            <div className="flex items-center gap-3 p-3 bg-gray-100 rounded-lg">
              <div className="p-2 bg-pink-100 rounded-lg">
                <FaCreditCard className="text-lg text-pink-600" />
              </div>
              <div className="flex-1">
                <div className="mb-1 text-sm text-gray-600">{t('stk')}:</div>
                <div className="font-mono text-gray-800">{data?.bank_number}</div>
              </div>
            </div>

            {/* Ngày tạo */}
            <div className="flex items-center gap-3 p-3 bg-gray-100 rounded-lg">
              <div className="p-2 bg-red-100 rounded-lg">
                <FaCalendarAlt className="text-lg text-red-600" />
              </div>
              <div className="flex-1">
                <div className="mb-1 text-sm text-gray-600">{t('ngaytao')}:</div>
                <div className="font-mono text-gray-800">
                  {dayjs(data?.created_at).format('HH:mm DD/MM/YYYY')}
                </div>
              </div>
            </div>
          </div>

          {/* Footer Buttons */}
          <div className="p-4 pt-0 space-y-3">
            {/* <Button
              onClick={handleClose}
              size="large"
              className="w-full h-12 font-semibold text-white border-none rounded-lg bg-gradient-to-r from-green-500 to-green-600"
              icon={<FaCheck />}
            >
              {t("xac nhan")}
            </Button> */}
            <Button
              onClick={handleClose}
              size="large"
              className="w-full h-12 font-semibold text-white border-none rounded-lg bg-gradient-to-r from-gray-400 to-gray-500"
              icon={<FaTimes />}>
              {t('dong')}
            </Button>
          </div>
        </div>

        <style jsx>{`
          .custom-recharge-modal .ant-modal-content {
            padding: 0 !important;
            border-radius: 16px !important;
            overflow: hidden !important;
          }

          .custom-recharge-modal .ant-modal-body {
            padding: 0 !important;
          }

          .custom-recharge-modal .ant-modal-header {
            display: none !important;
          }

          .custom-recharge-modal .ant-modal-close {
            display: none !important;
          }

          /* Mobile responsiveness */
          @media (max-width: 480px) {
            .custom-recharge-modal {
              width: 95% !important;
              margin: 0 auto !important;
            }
          }

          /* Button hover effects */
          .custom-recharge-modal button:hover {
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
          }

          /* Smooth transitions */
          .custom-recharge-modal * {
            transition: all 0.2s ease !important;
          }

          /* Custom scrollbar if needed */
          .custom-recharge-modal ::-webkit-scrollbar {
            width: 4px;
          }

          .custom-recharge-modal ::-webkit-scrollbar-track {
            background: #f1f1f1;
          }

          .custom-recharge-modal ::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 2px;
          }

          .custom-recharge-modal ::-webkit-scrollbar-thumb:hover {
            background: #555;
          }

          /* Card hover effects */
          .custom-recharge-modal .bg-gray-50:hover {
            background-color: #f8fafc !important;
            transform: translateY(-1px);
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          }

          /* Icon container styling */
          .custom-recharge-modal .p-2.rounded-lg {
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          /* Typography enhancements */
          .custom-recharge-modal .text-lg.font-bold {
            letter-spacing: -0.02em;
          }

          .custom-recharge-modal .font-mono {
            font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;
          }

          /* Enhanced button styling */
          .custom-recharge-modal .w-full.h-12 {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            font-weight: 600;
            letter-spacing: 0.02em;
          }

          /* Status component styling within modal */
          .custom-recharge-modal .ant-tag {
            border-radius: 6px !important;
            font-weight: 500 !important;
            padding: 2px 8px !important;
          }
        `}</style>
      </Modal>
    </>
  );
}
